import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, BookOpen, Clock } from 'lucide-react';

export const GuidesSection = ({ guideArticles, otherGuides }) => (
  <section id="guides" className="container-ninja section-spacing" data-testid="hyrox-guides-section">
    <div className="max-w-4xl mx-auto">
      <p className="text-[#e8ff00] text-xs uppercase tracking-wider font-heading mb-3">Training &amp; Strategy</p>
      <h2 className="text-3xl md:text-4xl text-white font-heading mb-4">HYROX Guides &amp; Training Plans</h2>
      <p className="text-zinc-400 mb-8 max-w-2xl">
        From beginner race prep to advanced station strategies. Whether it&apos;s your first HYROX or you&apos;re chasing a PR, we&apos;ve got you covered.
      </p>

      <Link
        to="/blogs/article/science-backed-running-tips"
        className="group flex flex-col sm:flex-row sm:items-center gap-4 bg-[#e8ff00]/5 border border-[#e8ff00]/30 hover:border-[#e8ff00]/70 p-5 mb-8 transition-all"
        data-testid="hyrox-running-tips-callout"
      >
        <div className="flex-1 min-w-0">
          <span className="text-[10px] uppercase tracking-widest text-[#e8ff00] font-heading">New · Evidence Review</span>
          <h3 className="text-white font-heading text-lg mt-1 group-hover:text-[#e8ff00] transition-colors">
            8 Running Tips That Sound Fake — With The Actual Studies
          </h3>
          <p className="text-zinc-400 text-sm mt-1">
            Rotating two pairs of shoes cut injury risk 39% across 264 runners. Every tip with the study, sample size and honest effect size — built for the 8km you&apos;ll run on race day.
          </p>
        </div>
        <span className="text-[#e8ff00] text-xs font-heading uppercase tracking-wider inline-flex items-center gap-2 flex-shrink-0">
          Read the receipts <ArrowRight className="w-3 h-3 group-hover:translate-x-1 transition-transform" />
        </span>
      </Link>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-6">
        {guideArticles.slice(0, 6).map((a) => (
          <Link
            key={a.slug}
            to={`/blogs/article/${a.slug}`}
            className="group flex gap-4 bg-zinc-900/80 border border-zinc-800 hover:border-[#e8ff00]/30 p-4 transition-all"
            data-testid={`guide-${a.slug}`}
          >
            <img src={a.featured_image} alt={a.title} className="w-20 h-20 object-cover flex-shrink-0" loading="lazy" />
            <div className="flex-1 min-w-0">
              <span className="text-[10px] uppercase tracking-wider text-[#e8ff00] font-heading">Guide</span>
              <h4 className="text-white text-sm font-heading mt-0.5 line-clamp-2 group-hover:text-[#e8ff00] transition-colors" style={{ fontSize: '0.95rem' }}>
                {a.title}
              </h4>
              {a.read_time && (
                <span className="text-zinc-500 text-xs flex items-center gap-1 mt-1"><Clock className="w-3 h-3" />{a.read_time} min</span>
              )}
            </div>
          </Link>
        ))}
      </div>

      {[...guideArticles.slice(6), ...otherGuides].length > 0 && (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3">
          {[...guideArticles.slice(6), ...otherGuides].slice(0, 6).map((a) => (
            <Link
              key={a.slug}
              to={`/blogs/article/${a.slug}`}
              className="group flex items-center gap-3 bg-zinc-900/50 border border-zinc-800 hover:border-[#e8ff00]/20 px-4 py-3 transition-all"
              data-testid={`guide-extra-${a.slug}`}
            >
              <BookOpen className="w-4 h-4 text-zinc-600 flex-shrink-0" />
              <span className="text-zinc-300 text-sm truncate group-hover:text-[#e8ff00] transition-colors">{a.title}</span>
            </Link>
          ))}
        </div>
      )}
      <div className="mt-6 text-center">
        <Link to="/blog?category=HYROX" className="text-[#e8ff00] text-sm font-heading uppercase tracking-wider inline-flex items-center gap-2 hover:text-white transition-colors" data-testid="all-hyrox-articles-link">
          View All HYROX Articles <ArrowRight className="w-3 h-3" />
        </Link>
      </div>
    </div>
  </section>
);
